/* istanbul ignore file */
import React from 'react';
import { useAssetUrl } from 'domain/finance/assets/shared/useAssetRouting';
import { UPDATE_ASSET } from 'domain/finance/assets/useAssetService';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';

const EditAssetButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useAssetUrl();

  return <EditButton {...props} path={getUpdateEntityUrl} permissionToCheck={UPDATE_ASSET} />;
};

export default EditAssetButton;
